import { useState } from 'react'
import './styles.scss'
import Modal from 'react-modal'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('main')
interface Props {
	open: boolean
	openModal?: any
	closeModal?: any
	AgentsEmailAddress: string
}

export default function FormModal({ open, closeModal, AgentsEmailAddress }: Props) {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [formSuccess, setFormSuccess] = useState(false)
	const [captchaToken, setCaptchaToken] = useState(null);

	const validatePhoneNumber = (value: string) => {
		let error;
		const phoneRegex = /^[0-9]{10}$/;

		if (!value) {
			error = 'Phone number is required.';
		} else if (!phoneRegex.test(value)) {
			error = 'Please input a valid phone number.';
		}

		return error;
	};

	return (
		<Modal isOpen={open} onRequestClose={closeModal}>
			<button onClick={closeModal} className="button-close-modal">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="white"/>
				</svg>
			</button>
			<div className="row" style={{ margin: 0 }}>
				<div className="col-lg-7 modal-content-form">
					{!formSuccess ? (
						<>
							<h2 className="h1">Request Appraisal</h2>
							<p
								className="highlighted-text"
								style={{ marginBottom: 32 }}
							>
								We just need some details from you...
							</p>
							<Formik
								initialValues={{
									FirstName: '',
									LastName: '',
									Email: '',
									Phone: '',
									Address: '',
									PostCode: '',
									AgentsEmailAddress: AgentsEmailAddress,
									RecaptchaToken: '',
								}}
								onSubmit={async (values, { setFieldValue }) => {
									if (!executeRecaptcha) {
										console.log("Recaptcha not ready");
										return;
									}

									// Trigger the reCAPTCHA check
									executeRecaptcha("submit_form").then((token) => {
										setCaptchaToken(token);
										setFieldValue('RecaptchaToken', token);
										values.RecaptchaToken = token;

										fetch('/umbraco/api/TeamEnquiryFormApi/SubmitTeamEnquiryForm', {
											method: 'POST',
											body: JSON.stringify(values),
											headers: {
												'Content-type':
													'application/json; charset=UTF-8',
											},
										})
										.then((res) => res.json())
										.then((data) => {
											if (data) {
												setFormSuccess(true)
											}
										})
									});
								}}
							>
								{({ errors, touched }) => (
									<Form>
										<div className="form-row">
											<div className="col-6">
												<div className="form-group">
													<label htmlFor="test">
														First Name
													</label>
													<Field
														id="test"
														className="form-control"
														placeholder="Your first name..."
														name="FirstName"
														required
													/>
												</div>
											</div>
											<div className="col-6">
												<div className="form-group">
													<label>Last Name</label>
													<Field
														className="form-control"
														placeholder="Your last name..."
														name="LastName"
														required
													/>
												</div>
											</div>
										</div>
										<div className="form-group">
											<label>Email</label>
											<Field
												className="form-control"
												placeholder="Your email..."
												name="Email"
												type="Email"
												required
											/>
										</div>
										<div className="form-group">
											<label>Phone Number</label>
											<Field
												className="form-control"
												placeholder="Phone Number"
												validate={validatePhoneNumber}
												name="Phone"
												required
											/>
											<ErrorMessage name="Phone" component="div" className="error serif" />
										</div>
										<div className="form-row">
											<div className="col-6">
												<div className="form-group">
													<label htmlFor="test">
														Address
													</label>
													<Field
														id="test"
														className="form-control"
														placeholder="Address"
														name="Address"
													/>
												</div>
											</div>
											<div className="col-6">
												<div className="form-group">
													<label>Post Code</label>
													<Field
														className="form-control"
														placeholder="Post Code"
														name="PostCode"
														required
													/>
												</div>
											</div>
										</div>
										<Field
											type="hidden"
											name="AgentsEmailAddress"
											value={AgentsEmailAddress}
										/>
										<Field
											type="hidden"
											name="RecaptchaToken"
										/>
										<div
											id="error-message"
											className="my-32 form-group"
											style={{ display: 'none' }}
										>
											<p className="text-danger"></p>
										</div>
										<div className="text-center form-group">
											<button
												type="submit"
												className="my-32 btn form-submit brand accent btn--wide"
												style={{ width: '100%' }}
											>
												Submit
											</button>
										</div>
									</Form>
								)}
							</Formik>
						</>
					) : (
						<div>
							Thank you. Your request has been submitted.
							<br />
							<br />
							We will be in touch as soon as possible.
							<br />
							<br />
							In the mean time if it is urgent, please contact the
							office on 9977 3300.
							<br />
							<br />
							Clarke & Humel
						</div>
					)}
				</div>
				<div
					className="col-lg-5 d-none d-lg-block"
					style={{ padding: 0, display: 'flex' }}
				>
					<img
						src="/media/m4ifamcp/premium54841687.jpg?width=436&height=608&mode=crop&quality=70"
						alt='modal'
						style={{
							width: '100%',
							height: '100%',
							right: -1,
							position: 'relative',
						}}
					/>
				</div>
			</div>
		</Modal>
	)
}
